import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Dashboard from './components/Dashboard';
import Forms from './components/Forms';
import Report from './components/Report';
import Landing from './components/Landing';
import Footer from './components/shared/Footer';
import TermsFull from './components/TermsFull'; // ⬅️ IMPORTANTE: página completa de términos

function AppContent() {
  const [scoreData, setScoreData] = useState(Array(10).fill(0));
  const [isFinished, setIsFinished] = useState(false);

  const location = useLocation();

  // Rutas donde NO quieres mostrar footer
  const hideFooterRoutes = ['/report-view', '/imprimir'];
  const hideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <div className="min-h-screen flex flex-col">
      
      {/* CONTENIDO PRINCIPAL */}
      <div className="flex-grow">
        <Routes>
          
          {/* Landing */}
          <Route path="/" element={<Landing />} />

          {/* Formulario + Dashboard */}
          <Route
            path="/formulario"
            element={
              <div className="p-6">
                {!isFinished ? (
                  <Forms 
                    setScoreData={setScoreData} 
                    onFinish={() => setIsFinished(true)} 
                  />
                ) : (
                  <Dashboard scoreData={scoreData} />
                )}
              </div>
            }
          />

          {/* Reporte */}
          <Route path="/report" element={<Report />} />

          {/* Página de términos completos */}
          <Route path="/terminos" element={<TermsFull />} />

        </Routes>
      </div>

      {/* FOOTER GLOBAL */}
      {!hideFooter && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
